/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * AddToWallet
 *
 */

import React, { memo, useRef } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Button,
  Text,
  Space,
  Conditional,
  List,
  Divider,
  Popup,
  Icon
} from '@cashfree-intl/coherent';
import useClickOutside from 'utils/hooks';
import CustomIcon from 'components/CustomIcons';
import { copyToClipboard } from 'utils/common';
import { BANK_DETAILS_META_DATA } from 'containers/Wallets/constants';
import { IAddToWallet } from 'containers/Wallets/types';
import { StyledBankDetailsSpace, StyledList, StyledWalletActivationWarningText } from '../../containers/Wallets/styled';
import { CURRENCY_SYMBOL, PLACEHOLDER_TEXT } from 'utils/constants';
import { StyledBankWrapper, StyledPopup, StyledSpace, StyledTag } from './styled';
import { getTruncatedAccountNumber } from './helper';

function AddToWallet({
  open,
  closeModal,
  confirmRechargeClickHandler,
  walletType,
  isWalletsIntro,
  bankDetails,
  getWalletInfo = () => { },
  bankList,
  isRefundDetails = false,
  balance
}: IAddToWallet) {
  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  const renderBankDetails = (
    <StyledBankDetailsSpace
      direction="column"
      className="px-2 py-2"
      gap={1}
    >
      <Text variant="b14" strong>
        Bank Details
      </Text>

      {BANK_DETAILS_META_DATA.map(detail => {
        return (
          <Space justifyContent="space-between">
            <Text color="bodyLight" variant="b12">
              {detail.displayText}
            </Text>
            <Space gap={1}>
              <Text>{bankDetails[(detail?.fieldValue)] || PLACEHOLDER_TEXT}</Text>
              <CustomIcon
                className='pointer'
                componentName="COPY_TO_CLIPBOARD"
                handleClick={copyToClipboard(bankDetails[(detail?.fieldValue)])}
              />
            </Space>
          </Space>
        );
      })}
    </StyledBankDetailsSpace>
  );

  const handleBtnClick = () => {
    if (confirmRechargeClickHandler) {
      confirmRechargeClickHandler();
    } else closeModal();
    if (!isWalletsIntro) getWalletInfo();
  };

  const getActiveList = (isPrimary: boolean) => {
    if (!bankList?.length) {
      return []
    }
    if (isPrimary) {
      return bankList?.filter((bank) => bank.isPrimary)
    }
    return bankList?.filter((bank) => !bank.isPrimary)
  }

  return (
    <Modal
      open={open}
      className="common-modal-wrapper"
      ref={modalRef}
      $maxWidth={480}
    >
      <ModalHeader>
        <div>
          <Conditional if={!isRefundDetails}>
            <div className="heading">Recharge Account Details</div>
          </Conditional>
          <Conditional if={isRefundDetails}>
            <div className="heading">Insufficient Amount</div>
          </Conditional>
        </div>
        <div
          className="close-modal"
          data-event-name="Recharge_Account_Details_Icon_Close"
          data-ignore-inner-text="true"
          onClick={closeModal}
        >
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent className="py-3">
        <div className="modal-content px-3 py-0" >
          <Conditional if={isRefundDetails}>
            <Space justifyContent='space-between' alignItems='center'>
              <Text variant="h16" color='bodyLight'>
                 Refund Wallet Balance
              </Text>
              <Text variant="h16" color='danger'>
                {`${CURRENCY_SYMBOL.INR} ${balance || PLACEHOLDER_TEXT}`} 
                {/* <CustomIcon componentName='REFRESH'/> */}
              </Text>
            </Space>
            <Divider />
          </Conditional>
          <Conditional if={walletType === 'Refund Wallet'}>
            <Conditional if={!isRefundDetails}>
              <Text variant="b14" className="mb-1" strong>
                Recharge your wallet for a minimum of {CURRENCY_SYMBOL.INR}5000 on the below bank details.
              </Text>
            </Conditional>
            <Conditional if={isRefundDetails}>
              <Text variant="b14" className="mb-1" strong>
                Recharge your wallet using the details mentioned below.
              </Text>
            </Conditional>

          </Conditional>
          <Text color="bodyLight" variant="b12" className='mb-2'>
            Standard TDR charges are applied to add money.
          </Text>
          {renderBankDetails}
          <Conditional if={bankList?.length > 0}>
            <StyledBankWrapper >
              <Text variant="b14" strong className='mb-1'>
                Recharge funds from your active Cashfree-linked accounts
                <Popup content="The recharges to the wallet are allowed only through Cashfree-linked accounts. Recharges from any other accounts are not permitted."
                  trigger={<span className='ml-1' ><Icon name='info-small' width={16} height={16} /></span>}
                />
              </Text>
              <Space direction='column' className='mt-1' gap='0.5'>
                <Text variant="b12" color='bodyLight'>{getActiveList(true)[0]?.fullName}
                  <StyledTag className='ml-1'>
                    Primary
                  </StyledTag>
                </Text>
                <Text variant="b12">{getTruncatedAccountNumber(getActiveList(true)[0]?.bankAccount, 'X', 4)}</Text>
              </Space>
              <Space className='mt-2' justifyContent='space-between'>
                {getActiveList(false).slice(0, 2).map((bank) => (
                  <Space direction='column' gap='0.5'>
                    <Text variant="b12" color='bodyLight'>{bank.fullName}
                    </Text>
                    <Text variant="b12">{getTruncatedAccountNumber(bank?.bankAccount, 'X', 4)}</Text>
                  </Space>

                ))}
                <Conditional if={getActiveList(false).slice(2).length}>
                  <StyledPopup content={
                    <StyledSpace className='p-2' justifyContent='space-between' wrap='wrap' gap='2'>
                      {getActiveList(false).slice(2).map((bank) => (
                        <Space direction='column' key={bank.bankAccount} gap='0.5'>
                          <Text variant="b12" color='bodyLight'>{bank.fullName}</Text>
                          <Text variant="b12">{getTruncatedAccountNumber(bank?.bankAccount, 'X', 4)}</Text>
                        </Space>
                      ))}
                    </StyledSpace>
                  } trigger={<Button link>+ {getActiveList(false).slice(2).length} account</Button>}
                    on='click'
                  />
                </Conditional>
              </Space>
            </StyledBankWrapper>
          </Conditional>
          <Space className="mt-3 mb-2" justifyContent="center">
            <Button primary size="medium" onClick={handleBtnClick} className='w-100'>
              Go Back
            </Button>
          </Space>
        </div>
        <Divider />
        <div className='px-4 mt-2'>
          <List as='ul'>
            <List.Item as='li'>
              <Text variant="b12" color='bodyLight'>
                You won’t be able to recharge using UPI apps like Gpay, Phonepe etc.
              </Text>
            </List.Item>
            <List.Item as='li'>
              <Text variant="b12" color='bodyLight'>
                If you are transferring via Axis Bank then should add the beneficiary as “Other account” and not “Axis bank account”
              </Text>
            </List.Item>
            <List.Item as='li'>
              <Text variant="b12" color='bodyLight'>
                It usually takes 20-30 mins to reflect the money in the wallet.
              </Text>
            </List.Item>
          </List>
        </div>
      </ModalContent>
    </Modal>
  );
}

export default memo(AddToWallet);
